import PropTypes from 'prop-types'
import React from 'react'
import { getFormattedProfileKey } from 'utils/users'
import {
  ListGroup
} from 'react-bootstrap'
import UserComponent from 'components/User'
import UserContainer from 'components/ControlledUser'

export class UserPicker extends React.Component {
  static propTypes = {
    userIds: PropTypes.array,
    users: PropTypes.array,
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func,
    ignoreUsers: PropTypes.array,
    selectedUsers: PropTypes.array,
    filter: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      selectedUsers: props.selectedUsers || []
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.selectedUsers !== this.props.selectedUsers) {
      this.setState({
        selectedUsers: nextProps.selectedUsers || []
      })
    }
  }

  getSelectedUsers () {
    return this.state.selectedUsers
  }

  render () {
    const {
      userIds,
      users,
      onSelect,
      onDeselect,
      ignoreUsers = [],
      filter,
      ...props
    } = this.props
    const {
      selectedUsers
    } = this.state

    const renderUser = (user) => {
      let id
      if (typeof user === 'number') {
        id = user
      } else {
        id = user.profileKey
      }

      const onUserClick = () => {
        const isSelected = selectedUsers.indexOf(id) === -1

        this.setState({
          selectedUsers: isSelected
            ? [ ...selectedUsers, id ]
            : selectedUsers.filter(_id => _id !== id)
        })

        if (isSelected) {
          if (onSelect) onSelect(id)
        } else {
          if (onDeselect) onDeselect(id)
        }
      }

      if (userIds) {
        return (
          <UserContainer
            listItem
            key={id}
            id={id}
            onClick={onUserClick}
            active={selectedUsers.indexOf(id) >= 0}
            filter={filter} />
        )
      } else if (users) {
        return (
          <UserComponent
            {...user}
            listItem
            key={id}
            subtitle={getFormattedProfileKey(user.profileKey)}
            onClick={onUserClick}
            active={selectedUsers.indexOf(id) >= 0} />
        )
      }
    }

    return (
      <ListGroup {...props}>
        {userIds && userIds.filter(id => ignoreUsers.indexOf(id) === -1).map(id => {
          return renderUser(id)
        })}
        {users && users.map(user => {
          return renderUser(user)
        })}
      </ListGroup>
    )
  }
}

export default UserPicker

